// src/lib/ogClient.js
export async function fetchOgMeta(rawUrl) {
  const u = String(rawUrl || "").trim();
  try { new URL(u); } catch { throw new Error("Invalid URL"); }

  // CRA uses REACT_APP_* env prefix
  const base = process.env.REACT_APP_OG_PROXY_URL || "http://localhost:5174/og";
  const url = `${base}?url=${encodeURIComponent(u)}`;

  const res = await fetch(url, { headers: { accept: "application/json,*/*" } });
  const ct = res.headers.get("content-type") || "";

  if (ct.includes("application/json")) {
    const json = await res.json();
    if (!json?.ok) throw new Error(json?.error || "OG fetch failed");
    return json.data;
  } else {
    const text = await res.text();
    throw new Error(`OG proxy returned ${res.status} ${ct}. Body: ${text.slice(0,200)}`);
  }
}
